import AddPartner from './AddPartner';

export default AddPartner;
